import type { CardProduct } from './types';
import { ProductCard } from './ProductCard';

/** En rad. Två kort syns helt, det tredje sticker ut lite. Man scrollar i sidled för att se resten. */
export function RelatedRow({
  products,
  onSelect,
  title = 'Du kanske också gillar',
}: {
  products: CardProduct[];
  onSelect?: (p: CardProduct) => void;
  title?: string;
}) {
  if (products.length === 0) return null;
  return (
    <section className="cn-section">
      <h2 className="cn-h2 cn-gutter">{title}</h2>
      <div className="cn-related__row">
        {products.map((p) => (
          <div className="cn-related__item" key={p.id}>
            <ProductCard product={p} onSelect={onSelect} />
          </div>
        ))}
      </div>
    </section>
  );
}
